module.exports = __webpack_public_path__ + "9788f41e/img/arrow-share-icon.00a12c29.svg";